export default {
    created: function() {
        this.brushes = [];
        this.widgets = [];
    }
}